export default __webpack_public_path__ + "static/media/glass-panel.8510cd93.svg";